<template>
  <div class="card-info">
    <div class="container">
      <div id="test" ref="form"></div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    setTimeout(() => {
      var style = {
        base: {
          width: '100%',
          color: "#32325d",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "18px",
          "::placeholder": {
            color: "#aab7c4"
          }
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a"
        }
      };
      var elements = this.$env.stripe.elements();
      var cardElement = elements.create("card", { style });
      cardElement.mount("#test");

      this.$refs.form.addEventListener('submit', e => {

        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();

        stripe.createPaymentMethod({
          type: 'card',
          card: cardElement,
          billing_details: {
            email: this.$store.getters['user/data'].email,
          },
        }).then(stripePaymentMethodHandler);
      });
    }, 1000);
  }
}
</script>

<style lang="scss" scoped>

.card-info {
  .container {
    background: #fff;
    border: 1px solid #E4E5E6;
    max-width: 400px;
    width: 100%;
    padding: 10px;
    border-radius: 5px;
  }
}

</style>